// extracted by mini-css-extract-plugin
export var allEvents = "agenda-module--all-events--b5177";
export var editButtonTitle = "agenda-module--edit-button-title--dc3c0";
export var eventsContainer = "agenda-module--events-container--11fca";
export var eventsDescription = "agenda-module--events-description--21f46";
export var eventsItem = "agenda-module--events-item--6481c";
export var eventsItemDate = "agenda-module--events-item-date--732c6";
export var eventsItemDateFrom = "agenda-module--events-item-date-from--0776d";
export var eventsItemDateTo = "agenda-module--events-item-date-to--f0b11";
export var eventsItemImg = "agenda-module--events-item-img--df13f";
export var eventsItemRecurrence = "agenda-module--events-item-recurrence--f913f";
export var eventsItemTaxo = "agenda-module--events-item-taxo--b83f5";
export var eventsItemTitle = "agenda-module--events-item-title--721a3";
export var listEventsContainer = "agenda-module--list-events-container--96fd0";
export var listEventsTitle = "agenda-module--list-events-title--d2cfc";